/** Client-side encryption of DM attachments (AES-256-GCM, fresh key per file). */
import { asBufferSource, fromBase64, toBase64, toHex } from './encoding.js';
export async function encryptFile(plaintext) {
    const rawKey = crypto.getRandomValues(new Uint8Array(32));
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const key = await crypto.subtle.importKey('raw', rawKey, 'AES-GCM', false, ['encrypt']);
    const ct = new Uint8Array(await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, key, asBufferSource(plaintext)));
    const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', ct));
    return { ciphertext: ct, key: toBase64(rawKey), iv: toBase64(iv), sha256: toHex(digest) };
}
export async function decryptFile(ciphertext, ref) {
    const digest = toHex(new Uint8Array(await crypto.subtle.digest('SHA-256', asBufferSource(ciphertext))));
    if (digest !== ref.sha256)
        throw new Error('attachment integrity check failed');
    const key = await crypto.subtle.importKey('raw', asBufferSource(fromBase64(ref.key)), 'AES-GCM', false, ['decrypt']);
    const pt = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: asBufferSource(fromBase64(ref.iv)) }, key, asBufferSource(ciphertext));
    return new Uint8Array(pt);
}
//# sourceMappingURL=attachments.js.map